var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1813_44182)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1813_44182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.3989C0.632608 10.3989 0.759785 10.4516 0.853553 10.5454C0.947322 10.6392 1 10.7663 1 10.8989V13.3989C1 13.6642 1.10536 13.9185 1.29289 14.106C1.48043 14.2936 1.73478 14.3989 2 14.3989H14C14.2652 14.3989 14.5196 14.2936 14.7071 14.106C14.8946 13.9185 15 13.6642 15 13.3989V10.8989C15 10.7663 15.0527 10.6392 15.1464 10.5454C15.2402 10.4516 15.3674 10.3989 15.5 10.3989C15.6326 10.3989 15.7598 10.4516 15.8536 10.5454C15.9473 10.6392 16 10.7663 16 10.8989V13.3989C16 13.9294 15.7893 14.4381 15.4142 14.8132C15.0391 15.1882 14.5304 15.3989 14 15.3989H2C1.46957 15.3989 0.960859 15.1882 0.585786 14.8132C0.210714 14.4381 0 13.9294 0 13.3989V10.8989C0 10.7663 0.0526784 10.6392 0.146447 10.5454C0.240215 10.4516 0.367392 10.3989 0.5 10.3989Z",
    fill: "#356966"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.646 1.64494C7.69245 1.59838 7.74762 1.56143 7.80837 1.53623C7.86911 1.51102 7.93423 1.49805 8 1.49805C8.06577 1.49805 8.13089 1.51102 8.19163 1.53623C8.25238 1.56143 8.30755 1.59838 8.354 1.64494L11.354 4.64494C11.4479 4.73883 11.5006 4.86616 11.5006 4.99894C11.5006 5.13172 11.4479 5.25905 11.354 5.35294C11.2601 5.44683 11.1328 5.49957 11 5.49957C10.8672 5.49957 10.7399 5.44683 10.646 5.35294L8.5 3.20594V11.9989C8.5 12.1315 8.44732 12.2587 8.35355 12.3525C8.25979 12.4463 8.13261 12.4989 8 12.4989C7.86739 12.4989 7.74021 12.4463 7.64645 12.3525C7.55268 12.2587 7.5 12.1315 7.5 11.9989V3.20594L5.354 5.35294C5.30751 5.39943 5.25232 5.43631 5.19158 5.46146C5.13084 5.48662 5.06574 5.49957 5 5.49957C4.93426 5.49957 4.86916 5.48662 4.80842 5.46146C4.74768 5.43631 4.69249 5.39943 4.646 5.35294C4.59951 5.30645 4.56264 5.25126 4.53748 5.19052C4.51232 5.12978 4.49937 5.06468 4.49937 4.99894C4.49937 4.9332 4.51232 4.8681 4.53748 4.80736C4.56264 4.74662 4.59951 4.69143 4.646 4.64494L7.646 1.64494Z",
    fill: "#356966"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1813_44182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1813_44182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8140098cc82f9cc435c08f32b0dd917e.svg";
export { ForwardRef as ReactComponent };